/**
 * Which build of the client this is (SPEC §13.1, MT-112).
 *
 * Baked in at compile time by `vite.config.ts`, and compared against the
 * `X-Build-Version` header the API sends with every response. The two are the
 * same commit in a real deployment — the SPA is built into the API's wwwroot
 * and the pair ship as one artifact (ADR-002) — so a disagreement means this
 * client came out of a service worker's cache and the server has moved on.
 *
 * `local` on a developer machine, and the API's `App:Commit` defaults to the
 * same string for the same reason: a Vite dev server and a `dotnet run` are
 * always two different builds, and a prompt that is always on screen is a
 * prompt nobody reads when it matters.
 */
export const BuildVersion: string = import.meta.env.VITE_BUILD_VERSION || 'local'

/** The value both sides use to mean "not a deployment". */
export const UnversionedBuild = 'local'
